import React, { Component } from 'react'
import axios from 'axios'
import { Box, Button, TextField, Heading, Toast,Dropdown,Text } from 'monday-ui-react-core';
import DOMPurify from 'dompurify';
import env from "react-dotenv";
let baseUrl = process.env.REACT_APP_SERVER_URL;
export default class WorkOrderRequestForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            requestName: '',
            requestDescription: '',
            priorityValue:'',
            requestType:'',
            expectedCompletionDate:'',
            anyReferenceDoc:'',
            assetId: this.props.assetId,
            isLoading: false,
            successOrErrorMessageNotice: '',
            isToast: false,
            isToastOpen: false,
            messageSuccessOrFailure: '',
            managerId:this.props.managerId,
            priorityOptions:this.props.priorityOptions,
            requestTypeOptions:this.props.requestTypeOptions,
            serverUrl:''
        }
    }

    async componentDidMount() {
        const {assetId,managerId}=this.props; 
        const serverUrl=baseUrl;
        this.setState({
            serverUrl:serverUrl
        })
    }

    onChangeWorkRequestName=(event)=>{
        this.setState({
            requestName:event
        })
    }

    handlePriority=(event)=>{
        this.setState({
            priorityValue:event.value
        })
    }

    handleRequestType=(event)=>{
        this.setState({
            requestType:event.value
        })
    }

    onChangeExpectedCompleteDate=(event)=>{
        this.setState({
            expectedCompletionDate:event
        })
    }

    onChangeWorkRequestDescription=(event)=>{
        this.setState({
            requestDescription:event.target.value
        })
    }

    onChangeRefDoc=(event)=>{
        this.setState({
            anyReferenceDoc:event.target.files
        })
    }


    onClickCreateWorkRequest = async () => {
        this.setState({
            isLoading: true
        })
        let { requestName, requestDescription, priorityValue, requestType, anyReferenceDoc, assetId, expectedCompletionDate,managerId,serverUrl} = this.state;
        if (requestName && requestDescription && priorityValue && requestType && assetId && expectedCompletionDate) {
            const successMessasge = "Created a Work Request Successfully";
            const errorMessage = "Failed to create a work request";
            let formDataOfWorkOrder = {
                "workRequestName":requestName,
                "priority":priorityValue,
                "workRequestType":requestType,
                "expectedCompletionDate":expectedCompletionDate,
                "workRequestDescription":requestDescription,
                "assetId":assetId,
                "managerId":managerId
            };
            console.log("Manager Id ",formDataOfWorkOrder)
            await axios.post(`${serverUrl}/create-work-request`, formDataOfWorkOrder)
            .then(async(res) => {
                const formData=new FormData();
                const workOrderRequestId=res.data.workRequestItemId;
                if(workOrderRequestId!==null&&anyReferenceDoc.length!==0){
                    for(let fileObj=0;fileObj<anyReferenceDoc.length;fileObj++){
                        formData.append('files',anyReferenceDoc[fileObj])
                    }
                    formData.append('itemId',workOrderRequestId)
                    formData.append('fileColumn',"file")
                    await axios.post(`${serverUrl}/uploadFileLocal`,formData)
                    .then((res)=>{
                        // console.log("Uploaded ",res)
                    })
                    .catch((err)=>{
                        // console.log("Error ",err)
                    })
                }
                this.setState({
                    isLoading: false,
                    isToast: true,
                    messageSuccessOrFailure: successMessasge
                })
                window.location.replace(res.data.redirectionLink);
            })
            .catch((err) => {
                if (err.response.status === 401 || err.response.status === 404) {
                    this.setState({
                        isLoading: false,
                        isToast: true,
                        messageSuccessOrFailure: err
                    })
                }
                else {
                    this.setState({
                        isLoading: false,
                        isToast: true,
                        messageSuccessOrFailure: errorMessage
                    })
                }

            })
        }
        else {
            this.setState({
                isLoading: true
            })
            const errorMessage = "Please fill all the required fields";
            this.setState({
                isLoading: false,
                isToast: true,
                messageSuccessOrFailure: errorMessage,
            })
        }
    }


    render() {
        const { requestName, requestDescription,expectedCompletionDate , allocateComment, messageSuccessOrFailure, isToast,priorityOptions,requestTypeOptions } = this.state;
        return (
            <>
                <div>
                    {
                        isToast ?
                            <div>
                                {
                                    messageSuccessOrFailure === "Created a Work Request Successfully" ?
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.POSITIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div> :
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div>
                                }
                                {
                                    messageSuccessOrFailure === "Please fill all the required fields" ?
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div> : null
                                }
                            </div> : null
                    }
                    <br />
                    <br />
                    <Box className='box' border={Box.borders.DEFAULT} paddingX={Box.paddingXs.MEDIUM} paddingY={Box.paddingYs.MEDIUM} rounded={Box.roundeds.MEDIUM}>
                        <Heading value='Work Request Form' type={Heading.types.h2} style={{ textAlign: "center" }} />
                        <TextField
                            title="Work Request Name"
                            value={requestName}
                            type='text'
                            onChange={(event)=>this.onChangeWorkRequestName(event)}
                            requiredAsterisk={true}
                            wrapperClassName="monday-storybook-text-field_size"
                        />
                        <br />
                        <div style={{padding:'8px',paddingLeft:"0px"}}>
                            <Text>Priority<span className='asterisk'>*</span></Text>
                        </div>
                        <Dropdown placeholder="Choose Priority" options={priorityOptions} className="dropdown-stories-styles_big-spacing" onChange={(e)=>this.handlePriority(e)} />
                        <br />
                        <div style={{padding:'8px',paddingLeft:"0px"}}>
                            <Text>Request Type<span className='asterisk'>*</span></Text>
                        </div>
                        <Dropdown placeholder="Choose Request Type" options={requestTypeOptions} className="dropdown-stories-styles_big-spacing" onChange={(e)=>this.handleRequestType(e)} />
                        <br />
                        <TextField
                            title="Expected completion date"
                            value={expectedCompletionDate}
                            type='date'
                            onChange={(event)=>this.onChangeExpectedCompleteDate(event)}
                            requiredAsterisk={true}
                            wrapperClassName="monday-storybook-text-field_size"
                        />
                        <br />
                        <div style={{width:'100x',padding:'2px'}}>
                            <Text>Request Description<span className='asterisk'>*</span></Text>
                            <textarea
                                rows={4}
                                cols={32}
                                value={requestDescription}
                                onChange={(event)=>this.onChangeWorkRequestDescription(event)}
                                wrapperClassName="monday-storybook-text-field_size"
                                requiredAsterisk={true}
                            />
                        </div>
                        <br />
                        <div style={{padding:'8px',paddingLeft:"0px"}}>
                            <label><Text>Any Reference Document</Text></label>
                        </div>
                        <input type='file' multiple onChange={(event)=>this.onChangeRefDoc(event)}/>
                        <br />
                        <br />
                        <Button loading={this.state.isLoading} style={{ float: 'right' }} onClick={this.onClickCreateWorkRequest}>Submit</Button>

                    </Box>
                </div>
            </>
        )
    }
}
